import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { MarketsModifyComponent } from '../../markets/markets-modify/markets-modify.component';
import { GuardService } from '../../service/guard.service';

@Injectable({
  providedIn: 'root'
})
export class CanDeactivateMarketModifyGuard {
  constructor(private readonly guardService: GuardService) {}
  canDeactivate(component: MarketsModifyComponent): Observable<boolean> | boolean {
    return this.guardService.canDeactivate(component);
  }
}
